<div class="container-fluid mt-3">
	<a href="{{statementLink}}"><h4>View Current Statement</h4></a>
	<ng-container *ngIf="!statements">
		<h4>No Statements Found</h4>
	</ng-container>
	<ng-container *ngIf="statements">
	</ng-container>
</div>
